import http from "./httpService";
const apiEndpoint = "/conversation";

function allConversation(projectId) {
  return http.get(apiEndpoint + "/whitelabelGetAllThreads/" + projectId);
}

function deleteConversation(projectId, conversationId) {
  return http.delete(
    apiEndpoint +
      "/" +
      "whitelabelDeleteConversation" +
      "/" +
      projectId +
      "/" +
      conversationId
  );
}

function downloadExtractions({ projectId, body }) {
  return http.post(
    `${apiEndpoint}/whitelabelFetchExtractedData/${projectId}`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function downloadConversations({ projectId, body }) {
  return http.post(
    `${apiEndpoint}/whitelabelFetchConversationData/${projectId}`,
    body,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function getPaginatedConversations({ projectId, page, pageSize }) {
  return http.get(
    `${apiEndpoint}/whitelabelGetPaginatedThreadsv2/${projectId}?page=${page}&pageSize=${pageSize}`
  );
}

function getConversationById({ projectId, conversationId }) {
  return http.get(
    `${apiEndpoint}/whitelabelGetConversation/${projectId}/${conversationId}`
  );
}

function getConversationsBySearchTerm({ projectId, searchTerm }) {
  return http.get(
    `${apiEndpoint}/whitelabelSearchConversations/${projectId}?searchTerm=${searchTerm}`
  );
}

function changeHumanAgent(data, projectId, conversationId) {
  return http.patch(
    `/conversation/whitelabelChangeHumanAgentAssignment/${projectId}`,
    JSON.stringify({
      conversationId,
      ...data,
    }),
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function removeHumanAgent(projectId, conversationId) {
  return http.put(
    `/conversation/whitelabelRemoveHumanAgentAssignment/${projectId}/${conversationId}`
  );
}

function getMediaFromConversation({ projectId, conversationId, mediaId }) {
  return http.get(
    `${apiEndpoint}/whitelabelFetchWhatsAppMedia/${projectId}/${conversationId}/${mediaId}`,
    {
      responseType: "blob",
    }
  );
}

function getRecordingLink({ workspaceId, conversationId }) {
  return http.get(
    `${apiEndpoint}/portalGetRecordingLink/${workspaceId}/${conversationId}`,
    { responseType: "blob" }
  );
}

function manualRetryExtraction({ workspaceId, conversationId }) {
  return http.post(
    `${apiEndpoint}/whitelabelManualRetry/${workspaceId}/${conversationId}`
  );
}

function addTagToConversation({ workspaceId, conversationId, payload }) {
  return http.put(
    `${apiEndpoint}/whitelabelAddTag/${workspaceId}/${conversationId}`,
    payload
  );
}

function deleteTagFromConversation({ workspaceId, conversationId, payload }) {
  return http.delete(
    `${apiEndpoint}/whitelabelDeleteTag/${workspaceId}/${conversationId}`,
    {
      headers: { "Content-Type": "application/json" },
      data: payload,
    }
  );
}

function addNoteToConversation({ workspaceId, conversationId, payload }) {
  return http.put(
    `${apiEndpoint}/whitelabelAddNote/${workspaceId}/${conversationId}`,
    payload
  );
}

function deleteNoteFromConversation({ workspaceId, conversationId, noteId }) {
  return http.delete(
    `${apiEndpoint}/whitelabelDeleteNote/${workspaceId}/${conversationId}/${noteId}`
  );
}

function postArchiveConversation({ workspaceId, conversationId }) {
  return http.post(
    `${apiEndpoint}/whitelabelArchiveConversation/${workspaceId}/${conversationId}`
  );
}

function getConversationStats({
  workspaceId,
  assistantId,
  startTime,
  endTime,
}) {
  return http.get(
    `${apiEndpoint}/whitelabelGetConversationStats/${workspaceId}/${assistantId}`,
    {
      params: {
        startTime,
        endTime,
      },
    }
  );
}

// Per-turn token / latency metrics for one conversation; { enabled: false } unless the
// assistant's staff-only visibilitySettings.turnMetricsEnabled is on.
function getTurnMetrics({ workspaceId, conversationId }) {
  return http.get(
    `${apiEndpoint}/whitelabelGetTurnMetrics/${workspaceId}/${conversationId}`
  );
}

export {
  allConversation,
  deleteConversation,
  downloadConversations,
  downloadExtractions,
  getPaginatedConversations,
  getConversationById,
  getConversationsBySearchTerm,
  changeHumanAgent,
  removeHumanAgent,
  getMediaFromConversation,
  getRecordingLink,
  manualRetryExtraction,
  addTagToConversation,
  deleteTagFromConversation,
  addNoteToConversation,
  deleteNoteFromConversation,
  postArchiveConversation,
  getConversationStats,
  getTurnMetrics
};
